export default "__VITE_ASSET__DXqYNPJP__"